import { render, staticRenderFns } from "./product-price-panel.vue?vue&type=template&id=c83fffd8&"
import script from "./product-price-panel.vue?vue&type=script&lang=ts&"
export * from "./product-price-panel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports